import React from "react";
import PropTypes from "prop-types";
import cl from "classnames";
import Spaces from "./Spaces";
import { Subscribe } from "unstated";
import debounce from "lodash.debounce";
import SrpContainer from "../../containers/SrpContainer";
import { RefShape } from "../../shapes";
import LoadMoreButton from "./LoadMoreButton";
import Pagination from "../Pagination";
import classes from "../styles.module.scss";
import PlaceNotFound from "../PlaceNotFound";
import TooManyPages from "../TooManyPages";
import NoResults from "../NoResults";
import { SrpContext } from "../Filters/context";

const paddingTop = 20;

class SpaceList extends React.Component {
  static propTypes = {
    setPageInViewport: PropTypes.func.isRequired,
    pageInViewport: PropTypes.number.isRequired,
    theRef: RefShape.isRequired,
    data: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    if (typeof document !== "undefined")
      this.handleScroll = debounce(this.handleScroll.bind(this), 80);
  }

  componentDidMount() {
    if (typeof document !== "undefined")
      document.body.addEventListener("touchmove", this.handleScroll, {
        passive: true,
      });
  }

  componentWillUnmount() {
    if (typeof document !== "undefined")
      document.body.removeEventListener("touchmove", this.handleScroll);
  }

  handleScroll() {
    if (typeof document === "undefined") return;
    const { setPageInViewport } = this.props;
    const sections = Array.from(
      document.querySelectorAll("div[data-page]")
    ).reverse();
    const sectionOnScreen = sections.find((section) => {
      let pos = section.getBoundingClientRect().top - paddingTop;
      return pos < window.innerHeight; // on screen
    });
    if (sectionOnScreen) {
      const page = parseInt(sectionOnScreen.getAttribute("data-page"));
      setPageInViewport(page);
    }
  }

  render() {
    const { theRef, data } = this.props;

    if (data.unknown_place) return <PlaceNotFound />;

    if (data.all === 0) {
      if (data.pages > 0 && data.page > data.pages) return <TooManyPages />;
      return <NoResults />;
    }

    return (
      <SrpContext.Consumer>
        {({ mobileFiltersOpen }) => (
          <>
            <div
              className={cl("ux-spaces-tile", {
                "ux-spaces-tile--mobileFiltersOpen": mobileFiltersOpen,
              })}
            >
              <div
                className="ux-spaces-tile-scroll"
                ref={theRef}
                onScroll={this.handleScroll}
              >
                <Spaces
                  container={theRef}
                  mobileFiltersOpen={mobileFiltersOpen}
                />

                <div className={classes.Footer}>
                  <Pagination />
                  <LoadMoreButton />
                </div>
              </div>
            </div>
          </>
        )}
      </SrpContext.Consumer>
    );
  }
}

const SpaceListContainer = () => {
  const ref = React.createRef();

  return (
    <Subscribe to={[SrpContainer]}>
      {({ state: { pageInViewport, data }, setPageInViewport }) => (
        <SpaceList
          theRef={ref}
          pageInViewport={pageInViewport}
          setPageInViewport={setPageInViewport}
          data={data}
        />
      )}
    </Subscribe>
  );
};

export default SpaceListContainer;
